import React from 'react';
import { useSelector } from 'react-redux';

import { needBoundingSelector, mapControlSelector, gensetTrackReportIdSelector } from '../../../features/map/mapSlice';

import GoogleMapAssetBounder from './GoogleMapAssetBounder';
import GoogleMapZoneBounder from './GoogleMapZoneBounder';
import GoogleMapMarkerBounder from './GoogleMapMarkerBounder';
import GoogleMapTrackBounder from './GoogleMapTrackBounder';
import GoogleMapGensetBounder from './GoogleMapGensetBounder';
import GoogleGensetTrackBounder from './GoogleGensetTrackBounder';
import GoogleFindLatLngBounder from './GoogleFindLatLngBounder';
import GoogleMapRouteBounder from './GoogleMapRouteBounder';
import GoogleMapTripBounder from './GoogleMapTripBounder';

const GoogleMapControl = ({ map }) => {
    const needBounding = useSelector(needBoundingSelector);
    const mapControl = useSelector(mapControlSelector);
    const gensetTrackReportId = useSelector(gensetTrackReportIdSelector);
    if (needBounding) {
        return (
            <div>
                {mapControl === 'asset' && <GoogleMapAssetBounder map={map} />}
                {mapControl === 'zone' && <GoogleMapZoneBounder map={map} />}
                {mapControl === 'marker' && <GoogleMapMarkerBounder map={map} />}
                {mapControl === 'genset' && <GoogleMapGensetBounder map={map} />}
                {mapControl === 'track' && gensetTrackReportId && <GoogleGensetTrackBounder map={map} />}
                {mapControl === 'track' && !gensetTrackReportId && <GoogleMapTrackBounder map={map} />}
                {mapControl === 'findlatlng' && <GoogleFindLatLngBounder map={map} />}
                {mapControl === 'route' && <GoogleMapRouteBounder map={map} />}
                {mapControl === 'trip' && <GoogleMapTripBounder map={map} />}

            </div>
        )
    } else {
        return null;
    }
}

export default GoogleMapControl;
